module.exports = __webpack_public_path__ + "assets/img/share-doctor.a560b315.png";